import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { Home } from "@/pages/home";
import { NotFound } from "@/pages/not-found";
import { Providers } from "@/providers";

function AppRoutes() {
  return (
    <Router>
      <Providers>
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </Providers>
    </Router>
  );
}

export default AppRoutes;
